import { useState, useCallback } from "react";
export function useUppercaseCaution() {
  const {
    0: uppercaseCautionMessage,
    1: setUppercaseCautionMessage
  } = useState();
  const handleChange = useCallback(e => {
    const hasUppercase = /[A-Z]/.test(e.target.value);
    if (hasUppercase) {
      setUppercaseCautionMessage("大文字が入力されていますが正しいかご確認の上、次のステップにすすんでください");
    } else {
      setUppercaseCautionMessage(null);
    }
  }, []);
  return [handleChange, uppercaseCautionMessage];
}